import React, { useContext } from "react";
import Box from '@mui/material/Box';
import { FONT_COLOR } from '../const/general'

function HeaderSub(props) {
    return (
        <Box
            sx={{
                height: '16px',
                width: '100%',
                display: 'flex',
                alignItems: 'flex-start', 
                justifyContent: 'space-between',
                px: 1,
                color: FONT_COLOR,
                fontSize: {xs:'0.75rem',sm:'0.75rem', md:'clamp(0.375rem, -0.3rem + 1.2vw, 0.75rem)'},
                fontWeight: 'bold'
            }}
        >
            <Box sx={{ flexGrow: 1, textAlign: 'center'}}>
                {props.pageTitle}
            </Box>
            <Box mr={2} sx={{ minWidth: '80px', textAlign: 'right', color: '#ff0000' }}>
                {props.riskStatus}
            </Box>
            <Box mr={2} sx={{ minWidth: '80px', textAlign: 'right'}}>
                更新日時：{props.dateTime}
            </Box>
        </Box>
    );
}
export default HeaderSub;